import { useEffect } from "react";
import { findEntityByName } from "@qgiv/core-js";
import { submitPromoCodes } from "@qgiv/p2p-registration";
import { useDispatch } from "react-redux";

const UpdatePromoCodes = ({
    formId,
    promoCodes,
    registrations,
    submitValues,
    updatePromoCodes,
    updatePromoDiscounts,
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (
            registrations.length > 0 &&
            Object.keys(registrations[0]).length > 0 &&
            promoCodes.length > 0
        ) {
            submitPromoCodes(formId, submitValues)
                .then((response) => {
                    const { data } = response;
                    // Update the Redux state to pay attention the new registrants, updated registrations and added promo codes
                    dispatch(updatePromoDiscounts(data.response));
                    // if promoCode from array is invalid filter it out then update the state
                    if (data.response.ineligiblePromoCodes.length > 0) {
                        const promoCodeArray = promoCodes.filter((promo) => {
                            const invalidPromo =
                                data.response.ineligiblePromoCodes.find(
                                    findEntityByName(promo),
                                );
                            if (invalidPromo && invalidPromo.name === promo) {
                                return null;
                            } else {
                                return promo;
                            }
                        });
                        dispatch(updatePromoCodes(promoCodeArray));
                    }
                })
                .catch((errors) => {
                    console.error(errors);
                });
        }
    }, [registrations]);

    return null;
};

export default UpdatePromoCodes;
